import StoredLayout from '../../layouts/StoredLayout'
import DonutChartWidgets from './DonutChartWidgets'
export default StoredLayout(DonutChartWidgets)
